import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

// components
import { AboutDiscoverContainer } from '../AboutDiscover/AboutDiscoverContainer';
import { FeedLoader } from './FeedLoader/FeedLoader';
import { FeedSettings } from './FeedSettings/FeedSettings';
import { DiscoverFeedTiles } from './DiscoverFeedTiles';

// helpers
import classnames from 'classnames';
import get from 'lodash.get';

// styles
import styles from './styles/DiscoveryFeed.scss';

function DiscoveryFeedComponent({ userId, viewer, isLoading, refetchDiscoverFeed }) {
    const discoveryFeed = get(viewer, 'discoveryFeed') || [];
    const tileCount = discoveryFeed.filter(Boolean).length;

    if (tileCount === 0) {
        return <AboutDiscoverContainer hasUserId refetchDiscoverFeed={refetchDiscoverFeed} />;
    }

    return (
        <React.Fragment>
            <div className={styles.headingContainer}>
                <div className={styles.title}>
                    <FormattedMessage id="discover.discoveryFeed.title" defaultMessage="Discover" />
                </div>
                <div className={styles.subheadingContainer}>
                    <div className={styles.subtitle}>
                        <FormattedMessage
                            id="discover.discoveryFeed.subtitle"
                            defaultMessage="Find daily inspiration from 1stdibs, and save your favorite pieces, styles and creators."
                        />
                    </div>
                    <FeedSettings viewer={viewer} onComplete={refetchDiscoverFeed} />
                </div>
            </div>
            {isLoading ? (
                <FeedLoader />
            ) : (
                <DiscoverFeedTiles
                    className={classnames(styles.grid, {
                        [styles.isVisible]: !isLoading,
                    })}
                    userId={userId}
                    discoveryFeed={discoveryFeed}
                    viewer={viewer}
                />
            )}
        </React.Fragment>
    );
}

DiscoveryFeedComponent.propTypes = {
    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    refetchDiscoverFeed: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};

export const DiscoveryFeed = createFragmentContainer(DiscoveryFeedComponent, {
    viewer: graphql`
        fragment DiscoveryFeed_viewer on Viewer {
            ...DiscoverFeedTiles_viewer
            ...FeedSettings_viewer
            discoveryFeed(userId: $userId) @include(if: $hasUserId) {
                ctaUrl
                ctaText
                description
                header
                imageUrl
                itemCreator
                itemId
                reasonMessage
                subtitle
                subtitleUrl
                tags {
                    name
                    url
                }
                title
                titleUrl
                tileType
            }
        }
    `,
});
